import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { SectionShell, SectionTitle } from '../SectionShell';
import { CTAButton } from '../CTAButton';
import { faqs } from '../../data/content';
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <SectionShell data-id="element-144" data-mp="2z2p7czw6jftu">
      <SectionTitle eyebrow="❓ Questions" title="Frequently asked questions" data-id="element-145" data-mp="2z4a0cl2uiqpl" />

      <ul className="space-y-2.5" data-id="element-146" data-mp="3ms9t1qjpwr6t">
        {faqs.map((faq, index) => {
        const isOpen = open === index;
        return <li key={faq.q} className="overflow-hidden rounded-xl border border-sky-400/15 bg-navy-800" data-id="element-147" data-mp="3rrcxb8rvitdq" data-mpi={index}>
              <h3 data-id="element-148" data-mp="3d2q6oawsqf77">
                <button type="button" onClick={() => setOpen(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-3 px-4 py-4 text-left transition-colors duration-150 ease-out hover:bg-navy-700" data-id="element-149" data-mp="3d15ntijugkp6">
                  <span className="text-sm font-semibold leading-snug text-white sm:text-base" data-id="element-150" data-mp="20q6xce64ocll">
                    {faq.q}
                  </span>
                  <ChevronDownIcon className={`h-5 w-5 shrink-0 text-sky-400 transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-151" data-mp="1vtgifu627n1r" />
                </button>
              </h3>
              {isOpen && <p className="border-t border-white/5 px-4 py-4 text-sm leading-relaxed text-sky-100/75" data-id="element-152" data-mp="2eimxn77n9wit">
                  {faq.a}
                </p>}
            </li>;
      })}
      </ul>

      <div className="mt-8" data-id="element-153" data-mp="2ohcfizzjjgz2">
        <CTAButton label="Get the TRT Decision Deck™" subline="$27 · 7-day guarantee" data-id="element-154" data-mp="2oh2nl6uxqzqq" />
      </div>
    </SectionShell>;
}